// import
import Component from 'minsky-kit/js/components/Component';
// private statics
const scrollVariable = { top: 0, left: 0, animating: false };

// class definition
export default class PageNav extends Component {
    // constructor
    constructor (args = {}, objectName = 'PageNav') {
        // debug toggle
        args.debug = args.debug || true;

        // super constructor
        super(args, objectName);

        this.sectionLinks = this.el.querySelectorAll('button');

        for (let i = 0; i < this.sectionLinks.length; i++) {
            this.sectionLinks[i].addEventListener('click', this.blm.add('onSectionLinkClick', onSectionLinkClick));
        }
    }

    activate (id) {
        if (id) {
            const activeSectionLink = this.el.querySelector(`button[data-section-id="${id}"]`);
            if (activeSectionLink) {
                for (let i = 0; i < this.sectionLinks.length; i++) {
                    this.sectionLinks[i].classList.remove('is-active');
                }

                activeSectionLink.classList.add('is-active');
            }
        }
    }

    // methods
    refresh () {

    }

    destroy () {
        super.destroy();
    }
}

// event handlers
function onSectionLinkClick (e) {
    e.preventDefault();
    const el = document.querySelector(`.festival-artist[data-section-id="${e.currentTarget.dataset.sectionId}"]`);
    // console.log(el);
    scrollToEl.call(this, el);
}

function boundingBoxeDoIntersecsWithPoint (p, b) {
    return !(b.left > p.left
        || b.right < p.left
        || b.top > p.top
        || b.bottom < p.top);
}

function getCenter (bb) {
    return {
        top:  bb.top + bb.height / 2,
        left: bb.left + bb.width / 2,
    };
}

function scrollToEl (el) {
    this.log('Scroll to ', el);

    // scroll to target, animated
    const offset = getOffsetToDocument(el);

    window.scrollTo({
        top:      offset.top - 100,
        left:     offset.left,
        behavior: 'smooth',
    });

    scrollVariable.animating = true;
}

function getOffsetToDocument (el) {
    const bodyRect = document.body.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    return {
        top:  elRect.top - bodyRect.top,
        left: elRect.left - bodyRect.left,
    };
}

function onScrollTick (e) {
    window.scroll(scrollVariable.left, scrollVariable.top);
}
